import PropTypes from 'prop-types';
import React from 'react';
import { Row, Col, FormGroup, ControlLabel, HelpBlock } from 'react-bootstrap';

import ModeOptionSelect from './ModeOptionSelect.react';
import ModeOptionCard from './ModeOptionCard.react';

export default class ModeOptions extends React.Component {
  render() {
    return (
      <FormGroup>
        <div className='cross-channel-help-block'>
          <ControlLabel>Mode Selection</ControlLabel>
          <HelpBlock>
            Select modes of contact or advertising you are considering for reaching
            your target universe.
          </HelpBlock>
        </div>


        <Row>
          { this.props.job.modeOptions.map(mode => (
            <ModeOptionSelect
              organizationId={this.props.organizationId}
              mode={mode}
            />))
          }
        </Row>

        <Row>
          <Col md={12}>
            { this.props.job.modeOptions.filter(mode => mode.selected).size > 0 &&
              <div className='cross-channel-help-block'>
                <ControlLabel>Costs and Budget Constraints</ControlLabel>
                <HelpBlock>
                  Enter an expected average cost for each mode in the format requested.  Note you
                  can always request additional Cross Channel analysis for the same target
                  universe if you want to adjust these costs later.
                </HelpBlock>
              </div>
            }

            <div className='deck-of-cards'>
              { this.props.job.modeOptions.map(mode => (
                <ModeOptionCard
                  organizationId={this.props.organizationId}
                  mode={mode}
                  advancedSettings={this.props.advancedSettings}
                />
                ))
              }
            </div>
          </Col>
        </Row>
      </FormGroup>
    );
  }
}

ModeOptions.propTypes = {
  job: PropTypes.object,
  organizationId: PropTypes.number,
  advancedSettings: PropTypes.bool,
};
